module.exports = __webpack_public_path__ + "static/media/Yan_Ru_Jhou_CV.0f459210.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Yan_Ru_Jhou_CV.pdf
// module id = 37
// module chunks = 0